import { FC, useMemo } from "react";

import { NO_VALUE_DISPLAY } from "@ryde/shared";

import { IRenderColumnTemplate } from "../_core";
import { FramerTooltip } from "../../../common";
import {
  formatHubSettingsCellSummary,
  HubStationsCellStyled,
  HubStationsCellSummary,
  HubStationsTooltipContent,
  useHubStationsTemplate,
} from "./parts";

export const HubStationsCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  e2eData,
}) => {
  const { items, firstItem, openStation } = useHubStationsTemplate({
    value,
  });

  const cellSummary = useMemo(
    () => formatHubSettingsCellSummary(items),
    [items],
  );

  if (!firstItem) {
    return <span>{NO_VALUE_DISPLAY}</span>;
  }

  const tooltipContent = (
    <HubStationsTooltipContent items={items} onStationOpen={openStation} />
  );

  return (
    <div className="cell_simple" data-e2e-custom={e2eData}>
      <FramerTooltip content={tooltipContent} rtlStrippedBottomLeftPlacement>
        <HubStationsCellStyled>
          <HubStationsCellSummary>{cellSummary}</HubStationsCellSummary>
        </HubStationsCellStyled>
      </FramerTooltip>
    </div>
  );
};
